export default [
    //内部工作系统
    //主页及登录等
    {
        path: "/",
        name: "manage",
        component: () => import('@/views/InnerFrame.vue'),
        children: [
            {
                path: "index",
                name: "Index",
                components: {
                    default: () => import('@/views/IndexContent/IndexContent.vue'),
                    indexCarousel: () => import('@/views/IndexContent/HomeCarousel.vue'),
                    quickNav: () => import('@/views/IndexContent/QuickNav.vue')
                },
            },
        ]
    },
    {
        path: "/login",
        name: "login",
        component: () => import('@/views/Account/Login.vue'),
    },
    {
        path: "/register",
        name: "register",
        component: () => import('@/views/Account/Register.vue'),
    },

    //账户管理
    {
        path: "/account",
        name: "account",
        component: () => import('@/views/WorkFrame.vue'),
        children: [
            {
                path: "accountCenter",
                name: "accountCenter",
                components: {
                    default: () => import('@/views/Account/AccountCenter.vue'),
                }
            },
        ]
    },

    //附属功能
    {
        path: "/rearService_i",
        name: "rearService_i",
        component: () => import('@/views/InnerFrame.vue'),
        children: [
            {
                path: "download",
                name: "download",
                components: {
                    default: () => import('@/views/RearService/ResourceCenter/Download.vue'),
                }
            },
        ]
    },
    //库存上传
    {
        path: "/goodsInitial",
        name: "goodsInitial",
        component: () => import('@/views/InnerFrame.vue'),
        children: [
            {
                path: "alter",
                name: "alter",
                components: {
                    default: () => import('@/views/ItemProcess/GoodsInitial.vue'),
                }
            },
        ]
    },
    //产品流程
    {
        path: "/item",
        name: "item",
        component: () => import('@/views/WorkFrame.vue'),
        children: [
            {
                path: "shell",
                name: "shell",
                components: {
                    default: () => import('@/views/ItemProcess/Shell.vue'),
                }
            },
            {
                path: "accumulator",
                name: "accumulator",
                components: {
                    default: () => import('@/views/ItemProcess/Accumulator.vue'),
                }
            },
            {
                path: "goods",
                name: "goods",
                components: {
                    default: () => import('@/views/ItemProcess/Goods.vue'),
                }
            },
            {
                path:"goods_c/:goods_id",
                name:"goods_c",
                component:() => import('@/views/ItemProcess/GoodsContent.vue'),
                props:true
            },
            {
                path: "material",
                name: "material",
                components: {
                    default: () => import('@/views/ItemProcess/Material.vue'),
                }
            },
            {
                path: "orderManage",
                name: "orderManage",
                components: {
                    default: () => import('@/views/ItemProcess/OrderManage.vue'),
                },
            },
            {
                path: "packageDetail/:packageId",
                name: "packageDetail",
                component: () => import('@/views/ItemProcess/PackageDetail.vue'),
                props:true
            },
            {
                path: "purchaseVerify",
                name: "purchaseVerify",
                components: {
                    default: () => import('@/views/ItemProcess/PurchaseVerify.vue'),
                },
            },
            {
                path: "purchaseOperation",
                name: "purchaseOperation",
                components: {
                    default: () => import('@/views/ItemProcess/PurchaseOperation.vue'),
                },
            },
            {
                path: "purchaseIn",
                name: "purchaseIn",
                components: {
                    default: () => import('@/views/ItemProcess/PurchaseIn.vue'),
                },
            },
        ]
    },

    //文档报告管理
    {
        path: "/archiveManage",
        name: "archiveManage",
        component: () => import('@/views/WorkFrame.vue'),
        children: [
            {
                path: "heatReport",
                name: "heatReport",
                components: {
                    default: () => import('@/views/ArchiveManage/HeatReport.vue'),
                },
            },
            {
                path: "hardReport",
                name: "hardReport",
                components: {
                    default: () => import('@/views/ArchiveManage/HardReport.vue'),
                },
            },
            {
                path: "ptReport",
                name: "ptReport",
                components: {
                    default: () => import('@/views/ArchiveManage/PtReport.vue'),
                },
            },
            {
                path: "hydraulicReport",
                name: "hydraulicReport",
                components: {
                    default: () => import('@/views/ArchiveManage/HydraulicReport.vue'),
                },
            },
            {
                path: "mtReport",
                name: "mtReport",
                components: {
                    default: () => import('@/views/ArchiveManage/MtReport.vue'),
                },
            },
            {
                path: "oilReport",
                name: "oilReport",
                components: {
                    default: () => import('@/views/ArchiveManage/OilReport.vue'),
                },
            },
            {
                path: "freeReport",
                name: "freeReport",
                components: {
                    default: () => import('@/views/ArchiveManage/FreeReport.vue'),
                },
            },
        ]
    },
    //文档报告页面
    {
        path: "/archive",
        name: "archive",
        component: () => import('@/views/WorkFrame.vue'),
        children: [
            {
                path: "materialCheck/:fileId",
                name: "materialCheck",
                component: () => import('@/views/ArchiveItem/MaterialCheck.vue'),
                props:true
            },
            {
                path: "mtReport/:fileId",
                name: "mtReport",
                component: () => import('@/views/ArchiveItem/MtReport.vue'),
                props:true
            },
            {
                path: "ptReport/:fileId",
                name: "ptReport",
                component: () => import('@/views/ArchiveItem/PtReport.vue'),
                props:true
            },
            {
                path: "heatReport/:fileId",
                name: "heatReport",
                component: () => import('@/views/ArchiveItem/HeatReport.vue'),
                props:true
            },
            {
                path: "orderPaper/:fileId",
                name: "orderPaper",
                component: () => import('@/views/ArchiveItem/OrderPaper.vue'),
                props:true
            },
            {
                path: "hydraulicReport/:fileId",
                name: "hydraulicReport",
                component: () => import('@/views/ArchiveItem/HydraulicReport.vue'),
                props:true
            },
            {
                path: "oilReport/:fileId",
                name: "oilReport",
                component: () => import('@/views/ArchiveItem/OilReport.vue'),
                props:true
            },
            {
                path: "hardReport/:fileId",
                name: "hardReport",
                component: () => import('@/views/ArchiveItem/HardReport.vue'),
                props:true
            },
        ]
    },
    //其他
    {
        path: "/any",
        name: "any",
        component: () => import('@/views/WorkFrame.vue'),
        children: [
            {
                path: "signature",
                name: "signature",
                components: {
                    default: () => import('@/views/Other/Signature.vue'),
                },
            },
            {
                path: "processManage",
                name: "processManage",
                components: {
                    default: () => import('@/views/Other/ProcessManage.vue'),
                },
            },
            {
                path: "workflowManage",
                name: "workflowManage",
                components: {
                    default: () => import('@/views/Other/WorkflowManage.vue'),
                },
            },
            {
                path: "drawManage",
                name: "drawManage",
                components: {
                    default: () => import('@/views/Other/DrawManage.vue'),
                },
            },
         
        ]
    },

]